var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "entry-dialog" },
    [
      _vm.middleVisible ? _c("div", { staticClass: "bg-gray" }) : _vm._e(),
      _c(
        "dialog-card",
        {
          attrs: { visible: _vm.middleVisible, title: _vm.title },
          on: {
            "update:visible": function ($event) {
              _vm.middleVisible = $event
            },
            "on-close": _vm.onCancel,
          },
          scopedSlots: _vm._u(
            [
              _vm.showCountryTip
                ? {
                    key: "countryMsg",
                    fn: function () {
                      return [
                        _c(
                          "el-alert",
                          {
                            attrs: {
                              type: "warning",
                              "show-icon": "",
                              closable: false,
                              simple: "",
                            },
                          },
                          [
                            _c(
                              "span",
                              { attrs: { slot: "title" }, slot: "title" },
                              [
                                _c(
                                  "t",
                                  {
                                    staticClass: "choose-country-style",
                                    attrs: {
                                      lang: _vm.$t(
                                        "HPP-web_register_country_tip_msg",
                                        { 0: _vm.countryLabel }
                                      ),
                                      tag: "span",
                                    },
                                  },
                                  [
                                    _c("b", {
                                      staticStyle: { color: "rgb(215, 0, 15)" },
                                    }),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                      ]
                    },
                    proxy: true,
                  }
                : null,
              _vm.footContext
                ? {
                    key: "footer",
                    fn: function () {
                      return [
                        _c("span", { staticClass: "foot-text" }, [
                          _vm._v(_vm._s(_vm.$t(_vm.footContext.span) + " ")),
                        ]),
                        _c(
                          "el-button",
                          {
                            staticClass: "foot-button",
                            attrs: { type: "link" },
                            on: { click: _vm.footerBtn },
                          },
                          [_vm._v(_vm._s(_vm.$t(_vm.footContext.btn)))]
                        ),
                      ]
                    },
                    proxy: true,
                  }
                : null,
            ],
            null,
            true
          ),
        },
        [
          _c("account-login", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.dialogType === "login",
                expression: "dialogType === 'login'",
              },
            ],
            ref: "login",
            attrs: { "auto-email": _vm.autoEmail, title: _vm.realyTitle },
            on: {
              "update:title": function ($event) {
                _vm.realyTitle = $event
              },
              "to-reset": function ($event) {
                return _vm.open("reset", { autoEmail: $event })
              },
              "close-card": _vm.onCloseHPCLogin,
            },
          }),
          _vm.dialogType === "chooseId"
            ? _c("choose-identity", { on: { "go-register": _vm.goRegister } })
            : _vm._e(),
          _vm.middleVisible
            ? _c("account-register-check-email", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.dialogType === "register",
                    expression: "dialogType === 'register'",
                  },
                ],
                ref: "register",
                attrs: { "auto-email": _vm.autoEmail, title: _vm.realyTitle },
                on: {
                  "update:title": function ($event) {
                    _vm.realyTitle = $event
                  },
                },
              })
            : _vm._e(),
          _c("account-reset", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.dialogType === "reset",
                expression: "dialogType === 'reset'",
              },
            ],
            ref: "reset",
            attrs: { "auto-email": _vm.autoEmail },
          }),
        ],
        1
      ),
      _c("select-service-type", {
        attrs: { onehikid: true },
        on: {
          comfirm: function ($event) {
            _vm.chooseTypeFn.resolve && _vm.chooseTypeFn.resolve()
          },
        },
        model: {
          value: _vm.showAccountType,
          callback: function ($$v) {
            _vm.showAccountType = $$v
          },
          expression: "showAccountType",
        },
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("warm_tips"),
            visible: _vm.updatedOHIDialog,
            area: 480,
            "show-close": false,
            "close-on-click-modal": false,
            "close-on-press-escape": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.updatedOHIDialog = $event
            },
          },
        },
        [
          _c("div", { staticClass: "updated_OHI_dialog_content" }, [
            _c("div", { staticClass: "updated_OHI_dialog_fail" }, [
              _vm._v(_vm._s(_vm.$t("error_tip_prefix_30"))),
            ]),
            _c("div", { staticClass: "updated_OHI_dialog_expain" }, [
              _vm._v(_vm._s(_vm.$t("can_not_use_hpc_login"))),
            ]),
            _c("div", { staticClass: "updated_OHI_dialog_img" }, [
              _c("img", {
                attrs: {
                  src: require("../../img/portal_OHI_update.png.webp"),
                  alt: "",
                },
              }),
            ]),
          ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.updatedOHIDialog = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("go_to_login")))]
              ),
            ],
            1
          ),
        ]
      ),
      _vm.azureLoginShow
        ? _c(
            "el-dialog",
            {
              staticClass: "third-login-dialog",
              attrs: {
                title: _vm.$t("account"),
                visible: _vm.azureLoginShow,
                area: 520,
                "close-on-click-modal": false,
                "close-on-press-escape": false,
              },
              on: {
                "update:visible": function ($event) {
                  _vm.azureLoginShow = $event
                },
                close: _vm.onCloseAzureLoginDialog,
              },
            },
            [
              _c(
                "el-form",
                {
                  ref: "azureLoginForm",
                  staticClass: "azure-login-form",
                  attrs: {
                    "label-position": "top",
                    model: _vm.azureLoginForm,
                    rules: _vm.azureLoginRules,
                    "label-width": "24px",
                  },
                },
                [
                  !_vm.googleLoginShow
                    ? _c(
                        "el-form-item",
                        {
                          ref: "emailFormItem",
                          attrs: { label: _vm.$t("e-mail"), prop: "email" },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              tips: _vm.$t("v_email"),
                              placeholder: _vm.$t("e-mail"),
                              maxlength: 128,
                            },
                            nativeOn: {
                              keypress: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                )
                                  return null
                                return _vm.confirmAzureEmail.apply(
                                  null,
                                  arguments
                                )
                              },
                            },
                            model: {
                              value: _vm.azureLoginForm.email,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.azureLoginForm,
                                  "email",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "azureLoginForm.email",
                            },
                          }),
                          _vm.noEmailErrorTxt
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "el-form-item__error my-false-item",
                                },
                                [_vm._v(_vm._s(_vm.noEmailErrorTxt))]
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.googleLoginShow
                    ? _c(
                        "el-form-item",
                        {
                          ref: "idpIdFormItem",
                          attrs: {
                            label: _vm.$t(
                              "HPP-web_company_idetification_code_name"
                            ),
                            prop: "idpId",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: _vm.$t("please_enter"),
                              maxlength: 128,
                            },
                            nativeOn: {
                              keypress: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                )
                                  return null
                                return _vm.confirmAzureEmail.apply(
                                  null,
                                  arguments
                                )
                              },
                            },
                            model: {
                              value: _vm.azureLoginForm.idpId,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.azureLoginForm,
                                  "idpId",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "azureLoginForm.idpId",
                            },
                          }),
                          _vm.idpIdErrorTxt
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "el-form-item__error my-false-item",
                                },
                                [_vm._v(_vm._s(_vm.idpIdErrorTxt))]
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.needAzureVerifyCode
                    ? _c(
                        "el-form-item",
                        {
                          ref: "verifyAzureCodeFormItem",
                          attrs: {
                            label: _vm.$t("enter_img_verify_code"),
                            prop: "verifyCode",
                          },
                        },
                        [
                          _c("el-input", {
                            directives: [
                              { name: "input-limit", rawName: "v-input-limit" },
                            ],
                            staticClass: "azure-login-code-input",
                            attrs: {
                              placeholder: _vm.$t("enter_img_verify_code"),
                              "data-input-type": "alphanumeric",
                              maxlength: 4,
                            },
                            nativeOn: {
                              keypress: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                )
                                  return null
                                return _vm.confirmAzureEmail.apply(
                                  null,
                                  arguments
                                )
                              },
                            },
                            model: {
                              value: _vm.azureLoginForm.verifyCode,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.azureLoginForm,
                                  "verifyCode",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "azureLoginForm.verifyCode",
                            },
                          }),
                          _vm.AzureVerifyImg
                            ? _c("img", {
                                staticClass: "azure-login-code-pic",
                                attrs: {
                                  title: _vm.$t(
                                    "HPP-web_change_azure_code_msg"
                                  ),
                                  src: _vm.AzureVerifyImg,
                                  alt: "",
                                  crossorigin: "anonymous",
                                },
                                on: { click: _vm.changeAzureCode },
                              })
                            : _vm._e(),
                          _vm.verifyErrorTxt
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "el-form-item__error my-false-item",
                                },
                                [_vm._v(_vm._s(_vm.$t(_vm.verifyErrorTxt)))]
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "div",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", loading: _vm.confirmLoading },
                      on: {
                        click: function ($event) {
                          return _vm.confirmAzureEmail()
                        },
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.googleLoginShow
                            ? _vm.$t("confirm")
                            : _vm.$t("next_step")
                        )
                      ),
                    ]
                  ),
                  _vm.googleLoginShow
                    ? _c(
                        "el-button",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.onCloseAzureLoginDialog()
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("cancel")))]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }